import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const SwitchInput = ({
  value,
  onChange,
  disabled = false,
  size = 'default',
  loading = false,
  checkedChildren,
  unCheckedChildren,
  style,
  className,
  ...props
}) => {
  const { theme } = useTheme();

  const customStyle = {
    // Personalização baseada no tema
    ...style,
  };

  return (
    <Switch
      checked={value}
      onChange={onChange}
      disabled={disabled}
      size={size}
      loading={loading}
      checkedChildren={checkedChildren}
      unCheckedChildren={unCheckedChildren}
      style={customStyle}
      className={className}
      {...props}
    />
  );
};

SwitchInput.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'default']),
  loading: PropTypes.bool,
  checkedChildren: PropTypes.node,
  unCheckedChildren: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default SwitchInput; 